import { InformationCircleIcon } from "@heroicons/react/20/solid";
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function InfoBanner({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("text-balance rounded-md bg-blue-50 p-4", className)}>
      <div className="flex">
        <div className="shrink-0">
          <InformationCircleIcon
            aria-hidden="true"
            className="size-5 text-blue-400"
          />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <div className="text-sm text-blue-700">{children}</div>
        </div>
      </div>
    </div>
  );
}
